import { writable } from 'svelte/store';

const user = {};

const userStore = writable(user);

export default userStore;